import kr from '../kr/kr';

export default class HandleFormSubimt extends kr.Component {
    init() {
        this.submitForm();
    }
    submitForm() {
        const currentForm = document.querySelector('.reviews__form');
        let formDataObject = new FormData(currentForm);
        const submitButton = document.querySelector('.form__submit--review');
        const formInputs = document.querySelectorAll('.form__input');
        const formMessages = {
            'success': 'Message sent succesfully.', 
            'fail': 'Message could not be send. Chceck if every field is valid.'
        };
        const formMessageHolder = document.querySelector('.form__message');
        currentForm.addEventListener('submit', event=> {
            formInputs.forEach(el=> {
                if(el.getAttribute('type') === 'file') {
                    formDataObject.append(`${el.getAttribute('name')}`, `${el.files[0]}`);
                }else {
                    formDataObject.append(`${el.getAttribute('name')}`, `${el.value}`);
                }
            })
            fetch('https://www.planikafires.com/wp-json/form/review', {
                body: formDataObject,
                method: "POST"
            })
            .then(response => response.json())
            .then(data => {
                if(data.success === true) {
                    formMessageHolder.innerText = formMessages['success'];
                }else {
                    formMessageHolder.innerText = formMessages['fail'];
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
            event.preventDefault();
        })
    }
}

kr.registerComponent('.form__submit--review', {
    component: HandleFormSubimt
});